exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".in-context-header-control__logo-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.75rem; }\n\n.in-context-header-control__logo-input {\n  flex: 1 1 18rem;\n  min-width: 0; }\n\n.in-context-header-control__logo-action {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: flex-end; }\n\n@media (max-width: 767px) {\n  .in-context-header-control__logo-row {\n    align-items: stretch; }\n  .in-context-header-control__logo-action {\n    width: 100%; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?sourceMap!./src/components/pages/pages/product/InContextHeaderControl.scss
// module id = 1378
// module chunks = 0